'use client';

import { GhostButton } from '@app/app/_components/GhostButton/GhostButton';
import { Heading } from '@app/app/_components/Heading/Heading';
import { Paragraph } from '@app/app/_components/Paragraph/Paragraph';
import { CloseOutlinedCircleIcon } from '@app/app/_icons/CloseOutlinedCircleIcon';
import { useTranslations } from 'next-intl';

interface Props {
    open: boolean;
    onClose: () => void;
}

export function HobbiesDetailsView({ open, onClose }: Props) {
    const t = useTranslations();

    if (!open) {
        return null;
    }

    return (
        <>
            <button
                type="button"
                className="fixed inset-0 z-30 bg-black opacity-45"
                onClick={onClose}
                aria-label={t('general.close')}
            />

            <div className="fixed inset-0 z-50 overflow-y-auto bg-neutral-50 md:flex md:items-center md:justify-center md:p-8">
                <div className="flex min-h-full w-full flex-col bg-neutral-50 md:min-w-dialog md:max-w-dialog">
                    <div className="mb-4 flex items-start justify-between px-4 py-4">
                        <Heading level="h2" className="flex-1 pt-1">
                            {t('eshop.life.whatIsWhat')}
                        </Heading>
                        <GhostButton onClick={onClose} className="flex-shrink-0">
                            <CloseOutlinedCircleIcon className="size-8" />
                        </GhostButton>
                    </div>

                    <div className="px-4">
                        {t.rich('eshop.life.hobbiesDetails', {
                            p: children => <Paragraph className="mb-4">{children}</Paragraph>,
                            title: children => <Paragraph isBold>{children}</Paragraph>,
                        })}
                    </div>
                </div>
            </div>
        </>
    );
}
